export default __webpack_public_path__ + "static/media/3006.c7428664.jpg";